/*
 * Copyright (c) 2026 GS Elektromedizinische Geraete G. Stemple GmbH, Germany - all rights reserved.
 * <p>
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 */

import { DialogTitle, Table } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import React from 'react';
import { useCSS } from '../../../provider/CSSProvider';
import style from './DataImportDialog.scss?inline';
import TableBody from '@mui/material/TableBody';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';

interface PatientDataImportDialogProps {
  isDialogOpen: boolean;
  // Tuple Format: Property Name, New Value, Old Value
  localizedDataDiff: [string, string | null, string | null][];
  onConfirm: () => void;
  onAbort: () => void;
}

export function DataImportDialog({
  isDialogOpen,
  localizedDataDiff,
  onConfirm,
  onAbort,
}: PatientDataImportDialogProps) {
  useCSS(style);

  return (
    <Dialog open={isDialogOpen} onClose={onConfirm} className='import-patient-data-dialog' closeAfterTransition={false}>
      <DialogTitle>Neue Datensätze übernehmen</DialogTitle>
      <DialogContent>
        <Table size='small' className='property-table'>
          <TableHead>
            <TableRow>
              <TableCell />
              <TableCell>Alt</TableCell>
              <TableCell>Neu</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {localizedDataDiff.map((patientProperty) => (
              <TableRow key={patientProperty[0]}>
                <TableCell className='name-cell'>{patientProperty[0]}</TableCell>
                <TableCell className='property-cell'>
                  {patientProperty[2] ?? <span className='empty-text'>(leer)</span>}
                </TableCell>
                <TableCell className='property-cell'>
                  {patientProperty[1] ?? <span className='empty-text'>(leer)</span>}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </DialogContent>
      <DialogActions>
        <Button className='cancel-button' variant='outlined' onClick={onAbort}>
          Meine Daten behalten
        </Button>
        <Button onClick={onConfirm} autoFocus variant='contained'>
          Daten übernehmen
        </Button>
      </DialogActions>
    </Dialog>
  );
}
